import { useContext, useEffect, useState } from "react";
import PopUp from "../PopUp";
import { useAppStore } from "../../store/useAppStore";
import { AppContext } from "../../App";

export default function CashmaticPopup() {
	const { sendLocalCommand } = useContext(AppContext);
	const { cashmatic, cashPaymentPopup } = useAppStore();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		console.log("cashmatic set to", cashmatic, cashPaymentPopup);
		if (cashmatic && !cashPaymentPopup && cashmatic.status != "idle") setVisible(true);
		else setVisible(false);
	}, [cashmatic, cashPaymentPopup]);

	if (!visible) return null;

	return (
		<PopUp
			customClass="cashmatic-popup"
			options={{
				size: "small",
				title: "Cashmatic",
				onClose: false,
			}}
		>
			<div className="inner-content">
				<h3>Stato: {cashmatic.status}</h3>
				<div className="buttons-group">
					<button
						onClick={() => sendLocalCommand("statusRequest", { cashmatic_id: cashmatic.id })}
						className="button"
					>
						Aggiorna stato
					</button>
				</div>
			</div>
		</PopUp>
	);
}
